<template>
  <div>
    <v-row justify="center" align="center">
      <v-col v-if="currentInstitution.section_categories.length >= 1">
        <v-select
          :items="filteredSections.firstSectionCategorySections"
          :label="`Choose ${section_types[currentInstitution.section_categories[0].type]}`"
          v-model="firstSection"
          item-text="title"
          class="filteredSections"
          item-value="id"
          hide-details="true"
          :error="formErrors.firstSectionError"
          :error-messages="formErrors.firstSectionError"
          :menu-props="{ overflowY: 'auto' }"
          outlined
        ></v-select>
      </v-col>
      <v-col v-if="currentInstitution.section_categories.length >= 2">
        <v-select
          :items="filteredSections.secondSectionCategorySections"
          :label="`Choose ${section_types[currentInstitution.section_categories[1].type]}`"
          v-model="secondSection"
          item-text="title"
          item-value="id"
          hide-details="true"
          :error="formErrors.secondSectionError"
          :error-messages="formErrors.secondSectionError"
          outlined
        ></v-select>
      </v-col>
      <v-col v-if="currentInstitution.section_categories.length >= 3">
        <v-select
          :items="filteredSections.thirdSectionCategorySections"
          :label="`Choose ${section_types[currentInstitution.section_categories[2].type]}`"
          v-model="thirdSection"
          item-text="title"
          hide-details="true"
          :error="formErrors.thirdSectionError"
          :error-messages="formErrors.thirdSectionError"
          item-value="id"
          outlined
        ></v-select>
      </v-col>
      <v-btn large v-if="!isButtonLoading" @click="getAndStoreRoom">
        <v-icon>mdi-check</v-icon>Select
      </v-btn>
      <v-progress-circular :width="3" color="primary" indeterminate v-else></v-progress-circular>
    </v-row>
    <h4 v-if="adminRoom.room">Selected Room: {{ getRoomName }}</h4>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import authApi from "@api/auth/base";
import Helper from "@utils/misc";

export default {
  name: "SelectRoom",
  data() {
    return {
      formErrors: {
        firstSectionError: null,
        secondSectionError: null,
        thirdSectionError: null
      },
      section_types: {
        1: "Standard",
        2: "Division",
        3: "Batch",
        4: "Year",
        5: "Department"
      },
      roomId: null,
      roomName: "",
      firstSection: null,
      secondSection: null,
      thirdSection: null,
      isButtonLoading: false
    };
  },
  computed: {
    ...mapGetters([
      "accessToken",
      "currentInstitution",
      "roomData",
      "adminRoom"
    ]),
    // sections without "All"
    filteredSections: function() {
      let categories = this.currentInstitution.section_categories;
      return {
        firstSectionCategorySections:
          categories.length >= 1
            ? categories[0].sections.filter(item => item.title != "All")
            : null,
        secondSectionCategorySections:
          categories.length >= 2
            ? categories[1].sections.filter(item => item.title != "All")
            : null,
        thirdSectionCategorySections:
          categories.length >= 3
            ? categories[2].sections.filter(item => item.title != "All")
            : null
      };
    },
    // gets room name by appending section names
    getRoomName: function() {
      return Helper.getRoomName(this.adminRoom.room);
    }
  },
  methods: {
    ...mapActions(["setSections", "setAdminRoom"]),
    //checks if the "necessary" sections were fileld
    checkIfSectionsFilled() {
      this.formErrors.firstSectionError = this.formErrors.secondSectionError = this.formErrors.thirdSectionError = null;
      let categoriesCount = this.currentInstitution.section_categories.length;
      if (categoriesCount >= 1 && !this.firstSection)
        this.formErrors.firstSectionError = "This field is required";
      if (categoriesCount >= 2 && !this.secondSection)
        this.formErrors.secondSectionError = "This field is required";
      if (categoriesCount >= 3 && !this.thirdSection)
        this.formErrors.thirdSectionError = "This field is required";
      return (
        !this.formErrors.firstSectionError &&
        !this.formErrors.secondSectionError &&
        !this.formErrors.thirdSectionError
      ); //returns false even if one of them is not null
    },

    // sends sections to the server and gets room in return and stores in state
    async getAndStoreRoom() {
      if (!this.checkIfSectionsFilled()) return;
      this.isButtonLoading = true;
      let roomFromServer = await authApi.getRoomFromSections(this.accessToken, {
        firstSection: this.firstSection,
        secondSection: this.secondSection,
        thirdSection: this.thirdSection
      });
      if (
        !Helper.handleErrors(roomFromServer, this.handleApiErrors, {
          isLoading: this.isButtonLoading
        })
      )
        return;
      this.isButtonLoading = false;
      this.setAdminRoom({
        room: roomFromServer,
        firstSection: this.firstSection,
        secondSection: this.secondSection,
        thirdSection: this.thirdSection
      });
    },

    handleApiErrors(err) {
      this.isButtonLoading = false;
      console.log(err);
    }
  },
  mounted() {
    this.firstSection = this.adminRoom.firstSection;
    this.secondSection = this.adminRoom.secondSection;
    this.thirdSection = this.adminRoom.thirdSection;
  }
};
</script>

<style scoped>
</style>